import Vuex from 'vuex'
import user from '@/store/modules/user'
import getters from './getters'
import dict from './modules/dict'
// 引入插件
import createPersistedState from "vuex-persistedstate";

const store = new Vuex.Store({
  modules: {
    user,
    dict,
  },
  getters,
  plugins: [
    createPersistedState({
      // 存储方式：localStorage、sessionStorage、cookies  默认: localStorage
      storage: window.localStorage,
      // 存储的 key 的key值
      key: "store",
      paths: ['user','dict']
    })
  ]

})

export default store
